import { pick } from 'ramda'
import { restrictedLeadKeys } from '../../const/restrictedLeadKeys'

const restrictedLead = pick(restrictedLeadKeys)

export { restrictedLead }
